<template>
    <div>
        <div class="smi-block-inner" style="position: relative;">
            
            <p class="menu-title" style="width: 100%">
                <span>
                    {{block.Title}}
                </span>
                <span>
                    <img :src="getURL4Image(block.Icon)" :title="block.Title"/>
                </span>
            </p>
            
            <ul style="margin-bottom: 35px; padding: 0" >
                <li v-for="menuItem, subIndex in block.MenuItems" :key="subIndex">
                    <a 
                            @click="itemClick(menuItem.Link, block.Active, block.DefaultView)" 
                            v-bind:class="getInActiveClass(block.Active)"
                    >
                        {{ menuItem.Title }}
                    </a>

                </li>
            </ul>

            <div style="position: absolute;bottom: 10px;" @click="defaultViewClick()">
                <input type="checkbox" v-model="block.DefaultView">
                <span class="checkBoxSpan label-text-control"> Start me at the default view</span>
            </div>
        </div>
        <app-subscription :block="block"/>
    </div>
</template>
<script>
import * as UI from '../services/mainUI';
import * as service from '../services/blockService';

import appSubscription from '../components/subscription';


export default {
    components:{
        appSubscription
    },
    props:["block"],

    methods: {
        getURL4Image: function(image){
            return UI.getURL4Image(image, location)
        },
        
        getInActiveClass: function(active){ 
            return UI.getInActiveClass(active)
        },
        
        defaultViewClick : function(){
            this.block.item.DefaultView = !this.block.item.DefaultView;
        },

        itemClick: function(href, active, isDefaultView){
            this.$emit('showLoading', true);
            this.login = true;
            service.itemClick(href, active, isDefaultView, this);
        }
    },
}
</script>